module.exports = __webpack_public_path__ + "hyperion-v2-static/img/menu_esri_black.b8d0f976.png";